import React from "react";
import { connect } from "react-redux";

const mapStateToProps = ({ loading }) => ({ loading });

export class Loading extends React.Component {
  render() {
    return (
      <div>
        {this.props.loading
          ? <div className="content-holder__cover">
              <div className="throbber">
                <i className="fa fa-spinner fa-spin fa-3x" />
              </div>
            </div>
          : null}
      </div>
    );
  }
}

export default connect(mapStateToProps)(Loading);
